/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type SiteNavItem_navigationModule = {
    readonly imageLink: string | null;
    readonly name: string | null;
    readonly linkData: {
        readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
    };
    readonly items: ReadonlyArray<{
        readonly name: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SiteNavDropdownContent_navigationModule">;
    readonly " $refType": "SiteNavItem_navigationModule";
};
export type SiteNavItem_navigationModule$data = SiteNavItem_navigationModule;
export type SiteNavItem_navigationModule$key = {
    readonly " $data"?: SiteNavItem_navigationModule$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SiteNavItem_navigationModule">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "SiteNavItem_navigationModule",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageLink",
                "storageKey": null
            },
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "LinkData",
                "kind": "LinkedField",
                "name": "linkData",
                "plural": false,
                "selections": [
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SeoLink_linkData"
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "NavigationTopLevel",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    (v0 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SiteNavDropdownContent_navigationModule"
            }
        ],
        "type": "NavigationModule",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '1b5ee7d96d8d47905eb1981c678c4852';
export default node;
